/* eslint-disable no-unused-vars */

// this component was originally a partial but has become a custom drag and drop
import React, {useState, useEffect, useRef} from 'react'
import Popup from '../../partials/OLIPopup';

function Draggable(props) {
  const initialStyle = props.data.style; 

  const [dragging, setDragging] = useState(false);
  const [style, setStyle] = useState(initialStyle);
  const [mouseOrigin, setMouseOrigin] = useState(null);
  const [positionOrigin, setPositionOrigin] = useState(null);
  const [clockSnapshot, setClockSnapshot] = useState([]);

  useEffect(() => {
    if (props.droppedStyle !== undefined) {
      const newStyle = { top: `${props.droppedStyle}px`, left: '674px', transform: "scale(.997)", zIndex: 1, cursor: "default"};
      props.setDraggableStyle(newStyle, props.id);
    }
  }, [props.droppedStyle])

  useEffect(() => {
    setClockSnapshot(null);
  }, [props.resetIndex])

  // useEffect(() => {

  //   console.log("useEffect props.totalTimeArray" , props.totalTimeArray);    
  //       let dropId = (props.totalTimeArray.length - 1)
  //       console.log("dropId" , dropId);
  //       console.log("totalTimeArray[dropId]" , props.totalTimeArray[dropId]);
  //       console.log("totalTimeArray[dropId] % 60" , props.totalTimeArray[dropId] % 60);

  //       setClockSnapshot(`${Math.floor(props.totalTimeArray[dropId] / 60)}:${(props.totalTimeArray[dropId] % 60)/10 < 1 ? '' : ''}${props.totalTimeArray[dropId] % 60}`)


      
  //       // setClockSnapshot(`${Math.floor(props.totalTimeArray[dropId] / 60)}:${(props.totalTimeArray[dropId] % 60)/10 < 1 ? '' : ''}${props.totalTimeArray[dropId] % 60}`);

  // }, [props.totalTimeArray])

  const onMouseDown = (e) => {
    if (props.droppedIndex > -1) {
      return
    }
    //start dragging;
    props.setDragging(true);
    //measure init mouse position
    props.setMouseOrigin({
      mouseX: (e.nativeEvent.pageX - (window.innerWidth - 1000) / 2),
      mouseY: e.nativeEvent.pageY
    })
    //measure start of drag el position
    props.setPositionOrigin({
      top: parseInt(props.draggableStyle.top), 
      left: parseInt(props.draggableStyle.left)
    })
    props.setCurrentDraggable(props.id)
  };

  const onMouseUp = (e, id) => {
    if (!props.dragging || e === undefined) {
      return
    } 
    props.setDragging(false);
    props.setCurrentDraggable(-1);
    const boundsClientRect = {
      x: Math.floor(props.boundsDiv.getBoundingClientRect().x + window.scrollX),
      y: Math.floor(props.boundsDiv.getBoundingClientRect().y + window.scrollY)
    }
    const localX = e.nativeEvent.pageX - boundsClientRect.x;
    const localY = e.nativeEvent.pageY - boundsClientRect.y;
    if (localY > props.droppableBounds.top && localY < props.droppableBounds.bottom && localX > props.droppableBounds.left && localX < props.droppableBounds.right) {
      if (!props.rejectDraggable(id)) {        
        let tempArray = props.droppedOrderPush(id)

        // console.log("id" , id);
        // console.log("props.data.time" , props.data.time);   
        console.log("tempArray" , tempArray);
           
        console.log("DROPPED props.totalTimeArray" , props.totalTimeArray);    
        let dropId = (tempArray.length - 1)
        //console.log("dropId" , dropId);
        //console.log("props.totalTimeArray[dropId]" , props.totalTimeArray[dropId]);
        //console.log("props.totalTimeArray[dropId] % 60" , props.totalTimeArray[dropId] % 60);
      
        setClockSnapshot(`${Math.floor(tempArray[dropId] / 60)}:${(tempArray[dropId] % 60)/10 < 1 ? '0' : ''}${tempArray[dropId] % 60}`);        
     
        //setClockSnapshot(`${Math.floor(props.clock / 60)}:${(props.clock % 60)/10 < 1 ? '0' : ''}${props.clock % 60}`);
      } else {
        props.setRejectedFeedback(props.rejectedFeedbacks[`draggable-${id}`]);
        props.setDraggableStyle({
          top: initialStyle.top,
          left: initialStyle.left,
          zIndex: 1,
          transform: "scale(1.0)"
        }, props.id);
      }
    } else {
      props.setDraggableStyle({
        top: initialStyle.top,
        left: initialStyle.left,
        zIndex: 1,
        transform: "scale(1.0)"
      }, props.id);
    }
  };

  // const onMouseMove = (e) => {
  //   //if dragging, update position of draggable
  //   if (props.dragging) {
  //   }
  // };

  const onMouseLeave = () => {
    onMouseUp();
  };

  return (
    <div className={`Draggable draggable-${props.data.class}`}
         style={props.draggableStyle}
         onMouseDown={onMouseDown}
         onMouseUp={e => onMouseUp(e, props.id)}
         onMouseLeave={onMouseLeave}
         >
      <div className="drag-hitbox"></div>
      <div className="drag-content" dangerouslySetInnerHTML={{__html: props.data.html}}></div>
      <div className={`time ${clockSnapshot === null ? 'hidden' : ''}`}>{clockSnapshot}</div>
    </div>
  )
}

function Droppable(props) {
  // This particular drag-n-drop effectively has 1 droppable.
  // when dropped on the droppable, a draggable snaps to a particular position (underneath the last snapped draggable 
  // or at the top of the droppable). While functionally we have one droppable, visually we have multiple "slots" for
  // draggables to snap into. Hence the draggables.map() below inside of a single droppable.
  return (
    <div className={`Droppable droppable-${props.data.class}`} style={props.data.style}>
      <div className="drop-hitbox"></div>
      <div className={`instructions`}><p>{props.data.instructions}</p></div>
      { [...Array(props.data.slots)].map((e,i) => {
        return (
          <div className={`slot`}>
            <div className="slot-text" dangerouslySetInnerHTML={{__html: i+1}}></div>
            <div className={`slot-background`} />
          </div>
        )
      })}
    </div>
  )
}
 
export default function DragAndDrop(props) {
  // map of droppables' boundaries
  const [droppableBounds, setDroppableBounds] = useState({});
  const [droppedOrder, setDroppedOrder] = useState([]);
  const [feedback, setFeedback] = useState(null);
  const [complete, setComplete] = useState(false);
  const [showIntro, setShowIntro] = useState(true);
  // increment to reset draggables
  const [resetIndex, setResetIndex] = useState(0);
  const boundsDiv = useRef(null);

  const [draggableStyles, setDraggableStyles] = useState([])
  const [dragging, setDragging] = useState(false);
  const [mouseOrigin, setMouseOrigin] = useState(null);
  const [positionOrigin, setPositionOrigin] = useState(null);
  const [currentDraggable, setCurrentDraggable] = useState(-1);
  const [rejectedFeedback, setRejectedFeedback] = useState(null);
  const [totalTimeArray, setTotalTimeArray] = useState([]);
  const [eachTaskTimeArray, setEachTaskTimeArray] = useState([]);

  const bounds = props.data.bounds

  const draggableMouseDown = (e) => {
  }

  const draggableMoving = (e) => {
    if (dragging) {
      const xDif = mouseOrigin.mouseX - ((e.nativeEvent.pageX - (window.innerWidth - 1000) / 2));
      const yDif = mouseOrigin.mouseY - (e.nativeEvent.pageY);

      const top = positionOrigin.top - yDif;
      const left = positionOrigin.left - xDif;
      if (checkBounds(top, left)) {
        const newStyle = {
          top: positionOrigin.top - yDif,
          left: positionOrigin.left - xDif,
          transform: 'scale(1.1)',
          zIndex: 99
        }
        setIndividualDraggableStyle(newStyle)
      } else {
        setMouseOrigin({
          mouseX: (e.nativeEvent.pageX - (window.innerWidth - 1000) / 2),
          mouseY: e.nativeEvent.pageY
        })
        setPositionOrigin({
          top: parseInt(draggableStyles[currentDraggable].top),
          left: parseInt(draggableStyles[currentDraggable].left)
        })
      }
    }
  }

  const draggableMouseUp = () => {
    setCurrentDraggable(-1);
    setDragging(false);
  }

  const setIndividualDraggableStyle = (style, index=currentDraggable) => {
    const newDraggableStyles = [...draggableStyles];
    newDraggableStyles[index] = style
    setDraggableStyles(newDraggableStyles);
  }

  const checkBounds = (top, left) => {
    if (top < bounds.top || top > bounds.bottom || left < bounds.left || left > bounds.right) {
      return false;
    }
    return true;
  }

  const calculateFeedback = () => {
    props.audioController.removeAudio(props.data.instructionAudio)
    let newFeedback = null;
    let complete = false;
    const incorrectRoundIndex = props.data.correctOrder.findIndex((e,i) => {
      if (e !== droppedOrder[i] && droppedOrder[i] !== undefined) {
        return true
      }
    })

    console.log("incorrectRoundIndex" , incorrectRoundIndex);
    console.log("droppedOrder" , droppedOrder);


    if (incorrectRoundIndex === -1) {
      console.log("droppedOrder.length" , droppedOrder.length);
      if (droppedOrder.length < 4) {
        newFeedback = props.data.incorrectFeedbacks[droppedOrder.length][`empty`];
        props.audioController.playAudioByName(`empty-${droppedOrder.length+1}`)
      } else {
        newFeedback = props.data.correctFeedback;
        complete = true
        props.audioController.playAudioByName(`correct`)
      }
    } else {    
      console.log("incorrectRoundIndex" , incorrectRoundIndex);
      console.log("props.data.incorrectFeedbacks[incorrectRoundIndex]" , props.data.incorrectFeedbacks[incorrectRoundIndex]);
      newFeedback = props.data.incorrectFeedbacks[incorrectRoundIndex][`draggable-${droppedOrder[incorrectRoundIndex]}`];
      if (droppedOrder.length === 4) {
        props.audioController.playAudioByName(`empty-4`)
      } else {
        props.audioController.playAudioByName(`draggable-${droppedOrder[incorrectRoundIndex]}`)
      }
    }
    
    setFeedback(newFeedback);
    return complete
    // const currentRound = droppedOrder.length-1;
    // const feedbackRoundIndex = incorrectFeedbacks.findIndex((e) => {
    //   return e.hasOwnProperty(`draggable-${i}`)
    // })
    // const feedback = incorrectFeedbacks[feedbackRoundIndex][`draggable-${id}`]
    // setIncorrectFeedback(feedback);
  }

  const rejectDraggable = (id) => {
    return props.data.rejectedDraggables[droppedOrder.length].findIndex(e => e === id) > -1
  }

  useEffect(() => {
    const droppableStyle= props.data.droppable.style
    const newDroppableBounds =  {
      top: droppableStyle.top,
      right: droppableStyle.left + droppableStyle.width,
      bottom: droppableStyle.top + droppableStyle.height,
      left: droppableStyle.left
    }
    setDroppableBounds(newDroppableBounds)
    console.log("props.data.droppable" , props.data.droppable);
  }, [props.data.droppable])

  useEffect(() => {
    setDraggableStyles(props.data.draggables.map(e => e.style));
    props.audioController.playAudioByName(props.data.introAudio);
    return () => {
      // audio cleanup
      props.audioController.removeAllAudio();
    }
  }, [])

  

  const handleDrop = (x,y,id) => {
    // init array of objects linking any draggables dropped into droppables
    const boundsClientRect = {
      x: Math.floor(boundsDiv.current.getBoundingClientRect().x + window.scrollX),
      y: Math.floor(boundsDiv.current.getBoundingClientRect().y + window.scrollY)
    }
    const localX = x - boundsClientRect.x;
    const localY = y - boundsClientRect.y;
    if (localY > droppableBounds.top && localY < droppableBounds.bottom && localX > droppableBounds.left && localX < droppableBounds.right) {

    }
    console.log("handleDrop" , currentDraggable);
  }

  const droppedOrderPush = index => {
    console.log("droppedOrderPush droppedOrder" , droppedOrder);    
    const newDroppedOrder = [...droppedOrder];
    newDroppedOrder.push(index);
    setDroppedOrder(newDroppedOrder);
    

    eachTaskTimeArray.push(props.data.draggables[index].time);
    console.log("eachTaskTimeArray" , eachTaskTimeArray);
    const sum =  eachTaskTimeArray.reduce((result,number)=> result + number);    
    console.log("sum" , sum);
    const newTotalTime = [...eachTaskTimeArray];
    newTotalTime.splice((eachTaskTimeArray.length - 1),1,sum); 

    console.log("newTotalTime!!!!!!" , newTotalTime); 
   
    setTotalTimeArray(newTotalTime)
    return newTotalTime  
  } 

  const reset = () => {
    setResetIndex(resetIndex+1);
    setDroppedOrder([]);
    setDraggableStyles(props.data.draggables.map(e => e.style));
    setTotalTimeArray([]);
    setEachTaskTimeArray([]);
   //setIncorrectFeedbackIndex(-1);
   setFeedback(null);
  }

  const retry = () => {
    props.audioController.removeAllAudio();
    props.setTimerResetIndex();
    reset();
  }

  const submit = () => {
    // let isComplete = true;
    // props.data.correctOrder.forEach((e,i) => {
    //   if (e !== droppedOrder[i]) {
    //     if (isComplete) {
    //       isComplete = false;
    //       setIncorrectFeedbackIndex(i);
    //     }
    //   }
    //   setComplete(isComplete);
    //})
    if (droppedOrder.length > 0) {
      const isComplete = calculateFeedback();
      setComplete(isComplete);
    }
  }

  const handleIntroComplete = () => {
    props.audioController.removeAudio(props.data.introAudio);
    props.audioController.playAudioByName(props.data.instructionAudio);
    setShowIntro(false)
  }

  const handleRejectedFeedbackComplete = () => {
    
  }

  return (
    <div className={`DragAndDrop ${props.fadeOut ? 'fade-out' : ''} ${props.data.class}`} onMouseMove={draggableMoving} onMouseUp={draggableMouseUp} >
      <div className={`header`}>
          <h2>{props.data.headerText}</h2>
          <div className={`yellow-line`} />
      </div>
      <div className={`global-button reset-button`} onClick={reset}>{props.data.resetText.toUpperCase()}</div>
      <div className={`global-button submit-button`} onClick={submit}>{props.data.submitText.toUpperCase()}</div>
      {showIntro &&
        <Popup data={props.data.introPopup} onComplete={handleIntroComplete} />
      }
      { feedback && 
        <Popup class={'drag-drop-feedback'} data={feedback} onComplete={complete ? props.onComplete : retry} />
      }
      {
        rejectedFeedback !== null && (
          <Popup class={'rejected-feedback'} data={rejectedFeedback} onComplete={() => setRejectedFeedback(null)} />
        )
      }
      <div className="bounds" ref={boundsDiv}>
        {
          draggableStyles.length > 0 && props.data.draggables.map((draggable, i) => {
            return <Draggable 
              key={i} id={i} 
              bounds={props.data.bounds} 
              data={draggable} 
              droppedIndex={droppedOrder.findIndex(e => i === e)}
              droppedStyle={props.data.droppedPositions[droppedOrder.findIndex(e=> i === e)]}
              resetIndex={resetIndex}
              droppableBounds={droppableBounds}
              boundsDiv={boundsDiv.current}
              droppedOrderPush={droppedOrderPush}
              clock={props.clock}
              draggableStyle={draggableStyles[i]}
              setDraggableStyle={setIndividualDraggableStyle}
              setPositionOrigin={setPositionOrigin}
              dragging={dragging}
              setDragging={setDragging}
              currentDraggable={currentDraggable}
              setCurrentDraggable={setCurrentDraggable}
              setMouseOrigin={setMouseOrigin}
              rejectDraggable={rejectDraggable}
              calculateFeedback={calculateFeedback}
              setRejectedFeedback={setRejectedFeedback}
              rejectedFeedbacks={props.data.rejectedFeedbacks}
              droppedOrder={droppedOrder}
              totalTimeArray={totalTimeArray}
            />
          })
        }
        <Droppable data={props.data.droppable}/>
      </div>
    </div>
  )
}